import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import MovieCard from '@/components/feature/MovieCard';
import { movies, series, genres, getHotMovies, getNewMovies } from '@/mocks/movies';

export default function HomePage() {
  const [heroIndex, setHeroIndex] = useState(0);
  const heroMovies = getHotMovies().slice(0, 4);

  useEffect(() => {
    const timer = setInterval(() => {
      setHeroIndex((prev) => (prev + 1) % heroMovies.length);
    }, 5000);
    return () => clearInterval(timer);
  }, [heroMovies.length]);

  const schemaOrg = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '星空影院 - 首页',
    description: '星空影院在线观看免费，海量高清电影、热播剧集、综艺节目任意看，无需注册，无需付费。',
    url: 'https://yukafile.github.io/',
    isPartOf: {
      '@type': 'WebSite',
      name: '星空影院',
      url: 'https://yukafile.github.io',
    },
  };

  return (
    <>
      <title>星空影院在线观看免费 | 高清电影免费看</title>
      <meta name="description" content="星空影院在线观看免费，海量高清电影、热播剧集、综艺节目任意看，无需注册，无需付费，随时随地畅享优质影视内容。支持手机、平板、电脑多端播放，画质清晰流畅，告别缓冲烦恼，立即免费观看！" />
      <meta name="keywords" content="星空影院在线观看免费,星空影院免费高清,星空影院电影在线看,星空影院最新电影,免费在线观看电影,高清电影免费播放,星空影院热播剧集" />
      <link rel="canonical" href="https://yukafile.github.io/" />
      <meta property="og:title" content="星空影院在线观看免费 | 高清电影免费看" />
      <meta property="og:description" content="星空影院在线观看免费，海量高清电影、热播剧集、综艺节目任意看，无需注册，无需付费，随时随地畅享优质影视内容。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://yukafile.github.io/" />
      <script type="application/ld+json">
        {JSON.stringify(schemaOrg)}
      </script>

      <section className="relative h-[480px] md:h-[620px] overflow-hidden">
        {heroMovies.map((movie, index) => (
          <div
            key={movie.id}
            className={`absolute inset-0 transition-opacity duration-1000 ${
              index === heroIndex ? 'opacity-100' : 'opacity-0'
            }`}
          >
            <img
              src={movie.poster}
              alt={movie.title}
              className="w-full h-full object-cover object-top"
            />
            <div className="absolute inset-0 bg-gradient-to-b from-background-950/70 via-background-950/40 to-background-950"></div>
          </div>
        ))}

        <div className="absolute inset-0 flex items-center">
          <div className="w-full px-4 md:px-6">
            <div className="max-w-3xl mx-auto text-center">
              <h1 className="font-heading text-3xl md:text-5xl font-bold text-foreground-50 mb-4 leading-tight">
                星空影院<span className="text-primary-500">在线观看免费</span>
              </h1>
              <p className="text-base md:text-lg text-foreground-400 mb-8 max-w-xl mx-auto leading-relaxed">
                海量高清电影、热播剧集、综艺节目任意看，无需注册，无需付费，随时随地畅享优质影视内容
              </p>

              <div className="flex items-center gap-3 max-w-lg mx-auto bg-background-950/60 backdrop-blur-md rounded-full border border-foreground-50/10 p-1.5 hover:border-primary-500/30 transition-all duration-300">
                <div className="flex-1 flex items-center gap-3 pl-4">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-search-line text-foreground-400 text-lg"></i>
                  </div>
                  <input
                    type="text"
                    placeholder="搜索您想看的电影、剧集..."
                    className="flex-1 bg-transparent text-sm md:text-base text-foreground-200 placeholder-foreground-500 outline-none py-2"
                  />
                </div>
                <button className="px-5 md:px-6 py-2.5 md:py-3 bg-primary-500 hover:bg-primary-600 text-background-950 font-medium rounded-full text-sm whitespace-nowrap cursor-pointer transition-all duration-300 hover:shadow-lg hover:shadow-primary-500/20">
                  搜索影片
                </button>
              </div>

              <div className="flex items-center justify-center gap-6 mt-8 flex-wrap">
                <div className="flex items-center gap-2 text-foreground-400 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                  </div>
                  <span>高清画质</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-400 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                  </div>
                  <span>无需注册</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-400 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                  </div>
                  <span>多端播放</span>
                </div>
                <div className="flex items-center gap-2 text-foreground-400 text-sm">
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-checkbox-circle-fill text-primary-500 text-sm"></i>
                  </div>
                  <span>流畅不卡顿</span>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="absolute bottom-6 left-1/2 -translate-x-1/2 flex items-center gap-2">
          {heroMovies.map((_, index) => (
            <button
              key={index}
              onClick={() => setHeroIndex(index)}
              className={`w-2 h-2 rounded-full transition-all duration-300 cursor-pointer ${
                index === heroIndex
                  ? 'bg-primary-500 w-6'
                  : 'bg-foreground-50/30 hover:bg-foreground-50/50'
              }`}
              aria-label={`切换到第${index + 1}张`}
            />
          ))}
        </div>
      </section>

      <section className="py-10 md:py-14 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center justify-between mb-6 md:mb-8">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                <a href="#featured">精选推荐</a>
              </h2>
              <p className="text-sm text-foreground-500 mt-1">为您精选的高分佳作</p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <span>查看全部</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {getHotMovies().slice(0, 6).map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 px-4 md:px-6 bg-background-900/50">
        <div className="max-w-[1280px] mx-auto">
          <div className="mb-6 md:mb-8 text-center">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
              <a href="#categories">电影分类</a>
            </h2>
            <p className="text-sm text-foreground-500 mt-1">按类型探索精彩内容</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-8 gap-3 md:gap-4">
            {genres.filter(g => g.key !== 'all').map((genre) => (
              <Link
                key={genre.key}
                to={`/category/${genre.key}`}
                className="group flex flex-col items-center gap-3 p-5 md:p-6 bg-background-800/60 rounded-xl border border-background-700/30 hover:border-primary-500/40 hover:bg-background-800 transition-all duration-300 cursor-pointer"
              >
                <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-500/10 group-hover:bg-primary-500/20 transition-all duration-300">
                  <i className={`${getGenreIcon(genre.key)} text-primary-500 text-xl md:text-2xl`}></i>
                </div>
                <span className="text-sm font-medium text-foreground-300 group-hover:text-primary-500 transition-colors duration-200 whitespace-nowrap">
                  {genre.label}
                </span>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center justify-between mb-6 md:mb-8">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                <a href="#latest">最新上映</a>
              </h2>
              <p className="text-sm text-foreground-500 mt-1">最新上线的精彩影片</p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <span>查看更多</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {getNewMovies().slice(0, 6).map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 px-4 md:px-6 bg-background-900/50">
        <div className="max-w-[1280px] mx-auto">
          <div className="flex items-center justify-between mb-6 md:mb-8">
            <div>
              <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
                <a href="#series">热播剧集</a>
              </h2>
              <p className="text-sm text-foreground-500 mt-1">追剧党不可错过的精彩</p>
            </div>
            <Link
              to="/category/all"
              className="flex items-center gap-1 text-sm text-primary-500 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap cursor-pointer"
            >
              <span>全部剧集</span>
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-arrow-right-line text-xs"></i>
              </div>
            </Link>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-4 md:gap-5">
            {series.map((s) => (
              <MovieCard key={s.id} movie={s} />
            ))}
          </div>
        </div>
      </section>

      <section className="py-10 md:py-14 px-4 md:px-6">
        <div className="max-w-[1280px] mx-auto">
          <div className="mb-6 md:mb-8 text-center">
            <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-50">
              <a href="#all-movies">全部影片</a>
            </h2>
            <p className="text-sm text-foreground-500 mt-1">发现更多优质影视内容</p>
          </div>
          <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4 md:gap-5">
            {movies.map((movie) => (
              <MovieCard key={movie.id} movie={movie} />
            ))}
          </div>
        </div>
      </section>
    </>
  );
}

function getGenreIcon(genre: string): string {
  const icons: Record<string, string> = {
    action: 'ri-sword-line',
    comedy: 'ri-emotion-laugh-line',
    drama: 'ri-clapperboard-line',
    scifi: 'ri-rocket-2-line',
    horror: 'ri-ghost-line',
    romance: 'ri-heart-line',
    animation: 'ri-palette-line',
    documentary: 'ri-earth-line',
  };
  return icons[genre] || 'ri-movie-line';
}